import { Moon, Sun, Laptop } from 'lucide-react';
import { SidebarMenuItem, SidebarMenuButton } from 'components/ui/sidebar';
import { MoreHorizontal } from 'lucide-react';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from 'components/ui/dropdown';
import { useTheme } from 'components/styles/theme-provider';

export function ModeToggle() {
    const { setTheme, theme } = useTheme();

    const isDark = theme === 'dark';
    const isLight = theme === 'light';
    const isSystem = theme === 'system';

    return (
        <DropdownMenu modal={false}>
            <SidebarMenuItem>
                <DropdownMenuTrigger asChild>
                    <SidebarMenuButton asChild size="sm">
                        <div className="flex cursor-pointer flex-row items-center">
                            {isDark && <Moon />}
                            {isLight && <Sun />}
                            {isSystem && <Laptop />}
                            Theme <MoreHorizontal className="ml-auto" />
                        </div>
                    </SidebarMenuButton>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                    <DropdownMenuItem
                        onClick={() => setTheme('light')}
                        className="cursor-pointer"
                    >
                        <Sun className="mr-2" /> Light
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        onClick={() => setTheme('dark')}
                        className="cursor-pointer"
                    >
                        <Moon className="mr-2" /> Dark
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        onClick={() => setTheme('system')}
                        className="cursor-pointer"
                    >
                        <Laptop className="mr-2" /> System
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </SidebarMenuItem>
        </DropdownMenu>
    );
}
